import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { CpForecastService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-body/control-page-forecast/cp-forecast-service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-control-page-forecast',
  templateUrl: './control-page-forecast.component.html',
  styleUrl: './control-page-forecast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CpForecastService]
})
export class ControlPageForecastComponent {

  forecast = this.forecastService.forecast;

  private sub = new Subscription();

  constructor(
    private forecastService: CpForecastService,
    private homesFacade: HomesFacade,
  ) { }

  async ngOnInit() {
    this.sub.add(this.homesFacade.currentHomeId$.pipe(isDefined()).subscribe(() => {
      this.forecastService.loadForecast();
    }));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
